"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getErrorMessage(error) {
  return error.errors;
}
exports.logError = (schemas, nodeId) => {
  for (let s of schemas) {
    let { schema, data } = s;
    try {
      schema.validateSync(data);
    } catch (error) {
      console.log(nodeId + ": ", getErrorMessage(error));
    }
  }
};
exports.isValid = (schemas, nodeId) => {
  let result = [];
  for (let s of schemas) {
    let { schema, data } = s;
    result.push(schema.isValidSync(data));
  }
  result = result.filter(x => !x);
  if (result.length > 0) {
    exports.logError(schemas, nodeId);
    return false;
  }
  return true;
};
//# sourceMappingURL=helper.js.map
